import { routerMiddleware } from 'connected-react-router';
import reduxDynamicMiddlewares from 'redux-dynamic-middlewares';

import asyncDataFetchMiddleware from '@bufferapp/async-data-fetch/lib/middleware';
import notificationsMiddleware from '@bufferapp/notifications/lib/middleware';

import queueMiddleware from '~/queue/middleware';
import sentMiddleware from '~/sent/middleware';
import gridMiddleware from '~/grid/middleware';
import pastRemindersMiddleware from '~/past-reminders/middleware';
import pendingTiktokMiddleware from '~/pending-tiktok/middleware';
import draftsMiddleware from '~/drafts/middleware';
import storiesMiddleware from '~/stories/middleware';
import postingScheduleSettingsMiddleware from '~/posting-schedule/middleware';
import generalSettingsMiddleware from '~/general-settings/middleware';
import languageSettingsMiddleware from '~/language-preferences/middleware';
import profileSidebarMiddleware from '~/profile-sidebar/middleware';
import clientAccessMiddleware from '~/client-access/middleware';
import bootstrapMiddleware from '~/bootstrap/middleware';
import i18nMiddleware from '~/i18n/middleware';
import pusherSyncMiddleware from '~/pusher-sync/middleware';
import switchPlanModalMiddleware from '~/switch-plan-modal/middleware';
import stripeMiddleware from '~/stripe/middleware';
import modalsMiddleware from '~/modals/middleware';
import manageAppsMiddleware from '~/manage-apps-extras/middleware';
import twoFactorAuthMiddleware from '~/two-factor-auth/middleware';
import dateTimePreferencesMiddleware from '~/date-time-preferences/middleware';
import maintenanceRedirectMiddleware from '~/maintenance-redirect/middleware';
import notificationsProviderMiddleware from '~/notifications-provider/middleware';
import profilesDisconnectedModalMiddleware from '~/profiles-disconnected-modal/middleware';
import accountNotificationsMiddleware from '~/account-notifications/middleware';
import campaignFormMiddleware from '~/campaign-form/middleware';
import campaignMiddleware from '~/campaign/middleware';
import campaignsListMiddleware from '~/campaigns-list/middleware';
import deleteCampaignModalMiddleware from '~/delete-campaign-modal/middleware';
import bookmarkletsMiddleware from '~/bookmarklets/middleware';
import trialCompleteModalMiddleware from '~/trial-complete-modal/middleware';
import hashtagGroupsMiddleware from '~/hashtag-group-manager/middleware';
import segmentTrackingMiddleware from '~/analytics-middleware/middleware';
import globalAccountMiddleware from '~/globalAccount/middleware';
import closeComposerModalMiddleware from '~/close-composer-confirmation-modal/middleware';
import temporaryBannerMiddleware from '~/temporary-banner/middleware';
import storyPreviewMiddleware from '~/story-preview/middleware';
import storyGroupComposerMiddleware from '~/story-group-composer/middleware';
import profileNavMiddleware from '~/profile-nav/middleware';

import actionsOnlyForAnalyzeMiddleware from '~/analytics/middleware';
import thirdpartyMiddleware from '~/thirdParty/middleware';
import profilesMiddleware from '~/profiles/middleware';
import orgMiddleware from '~/organizations/middleware';
import userMiddleware from '~/user/middleware';

export const getMiddleware = (history) => [
  routerMiddleware(history),
  actionsOnlyForAnalyzeMiddleware('hide'),
  asyncDataFetchMiddleware,
  i18nMiddleware,
  profileSidebarMiddleware,
  clientAccessMiddleware,
  bootstrapMiddleware,
  userMiddleware,
  orgMiddleware,
  profilesMiddleware,
  queueMiddleware,
  sentMiddleware,
  gridMiddleware,
  pastRemindersMiddleware,
  postingScheduleSettingsMiddleware,
  generalSettingsMiddleware,
  languageSettingsMiddleware,
  pusherSyncMiddleware,
  notificationsMiddleware,
  pendingTiktokMiddleware,
  switchPlanModalMiddleware,
  manageAppsMiddleware,
  stripeMiddleware,
  modalsMiddleware,
  twoFactorAuthMiddleware,
  dateTimePreferencesMiddleware,
  maintenanceRedirectMiddleware,
  draftsMiddleware,
  notificationsProviderMiddleware,
  profilesDisconnectedModalMiddleware,
  accountNotificationsMiddleware,
  bookmarkletsMiddleware,
  thirdpartyMiddleware,
  campaignFormMiddleware,
  campaignMiddleware,
  campaignsListMiddleware,
  deleteCampaignModalMiddleware,
  trialCompleteModalMiddleware,
  hashtagGroupsMiddleware,
  segmentTrackingMiddleware,
  globalAccountMiddleware,
  closeComposerModalMiddleware,
  storiesMiddleware,
  temporaryBannerMiddleware,
  storyPreviewMiddleware,
  storyGroupComposerMiddleware,
  profileNavMiddleware,

  actionsOnlyForAnalyzeMiddleware('reveal'),
  // Dynamic middlware insertion point (for lazy-loaded components)
  reduxDynamicMiddlewares,
];
